export default __webpack_public_path__ + "static/pigeon-look@2x-4265a74fe047b712e0a50d7461537965.png";